<template>
  <b-link
    v-if="isLoggedIn"
    :to="{name: 'UserNotificationsRoute'}"
    class="d-flex flex-row align-items-center nav-link position-relative"
    :disabled="this.$route.name === 'UserNotificationsRoute'"
    @click="resetHasNewNotifications"
  >
    <font-awesome-icon
      :icon="['far', 'bell']"
      class="large-icon"
    />
    <span
      v-if="hasNewNotificationsAvailable"
      class="dot notification-badge notification-badge-lg"
    />
  </b-link>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserNotificationsActionsModule } from '@/features/user-notifications/store/user-notifications-actions'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'NavbarNotificationsIcon'
})
export default class extends Vue {
  hasNewNotificationsAvailable : boolean | null = false
  lastTimeChecked: Date = new Date(1920, 1, 1)

  mounted(): void {
    this.hasNewNotifications()
    this.checkForNewNotifications()
  }

  isLoggedIn(): boolean {
    return !!UserModule.username
  }

  private checkForNewNotifications(): void {
    window.setInterval(this.hasNewNotifications, 1000 * 120) // Every 2 minutes
  }

  private async hasNewNotifications(): Promise<void> {
    if (!this.isLoggedIn()) {
      return
    }

    this.hasNewNotificationsAvailable = this.hasNewNotificationsAvailable || await UserNotificationsActionsModule.hasNewNotifications({ since: this.lastTimeChecked })
    this.lastTimeChecked = new Date()
  }

  private resetHasNewNotifications() {
    this.hasNewNotificationsAvailable = false
  }
}
</script>

<style lang="scss" scoped>
.large-icon {
  font-size: 1.5em;
}

.dot {
  height: 10px;
  width: 10px;
  background-color: #bd1f36;
  border-radius: 50%;
  display: inline-block;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);
}

.notification-badge{
  position: absolute;
  right: 4px;
  top: 13px;
}
</style>
